import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Route, Switch } from 'react-router-dom';

interface IState {
  unsavedChanges: boolean
  openDialog: boolean
}

interface IPage {
  component: React.ComponentClass
  props?: any
  routeAffix?: string
}

interface ITab {
  icon: JSX.Element
  label: string
  component: React.ComponentClass
  page: IPage
  subPages?: IPage[]
}

interface IProps {
  history?: any
  activeTab?: string | number
  tabs: ITab[]
  routeParm?: string
}

const styles = (theme: any) => ({
  tableContent: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});

class TabNavigation extends React.Component<IProps, IState> {

  public activeTab: string | number = 0

  constructor(props: any) {
    super(props);
    this.state = {
      unsavedChanges: false,
      openDialog: false
    }
    this.setUnsavedChangesFlag = this.setUnsavedChangesFlag.bind(this);
  }

  public setUnsavedChangesFlag(check: boolean) {
    this.setState({ ...this.state, unsavedChanges: check });
  }

  public handleTabChange = (event: any, selectedTab: string | number) => {
    if (this.state.unsavedChanges) {
      this.setState({ ...this.state, openDialog: true });
    }
    else {
      this.activeTab = selectedTab;
      if (this.props.routeParm) {
        // navigate to route
        const activePath = this.props.history.location.pathname
        const baseUrl = activePath.substring(0, activePath.indexOf(this.props.routeParm))
        this.props.history.push(baseUrl + this.activeTab)
      }
      else {
        this.forceUpdate();
      }
    }
  };

  public closeDialog = () => {
    this.setState({ ...this.state, openDialog: false });
  };

  public render() {
    if (this.props.activeTab) { this.activeTab = this.props.activeTab }
    if (this.props.routeParm) { this.activeTab = this.props.routeParm }
    return (
      <div>
        <Paper style={{ width: '100%' }}>
          <Tabs
            value={this.activeTab}
            onChange={this.handleTabChange}
            fullWidth={true}
            indicatorColor="secondary"
            textColor="secondary"
          >
            {this.props.tabs.map((tab: any, index: number) => {
              if (this.props.routeParm) {
                return <Tab key={index} value={tab.page.routeAffix} icon={tab.icon} label={tab.label} />
              }
              else {
                return <Tab key={index} icon={tab.icon} label={tab.label} />
              }
            })}
          </Tabs>
        </Paper>
        <div>
          <div style={{ paddingTop: '24px' }}>
            <Switch>
              {this.props.tabs.map((tab: ITab, tabIndex: number) =>
                this.props.routeParm && tab.subPages && tab.subPages.map((page: IPage, pageIndex: number) => {
                  const componentFactory = React.createFactory(page.component);
                  return (
                    <Route
                      path={'*/' + encodeURI(tab.page.routeAffix as string) + '/' + encodeURI(page.routeAffix as string)}
                      render={() => componentFactory({ ...page.props, unsavedChangesHandler: this.setUnsavedChangesFlag })}
                      key={pageIndex}
                    />
                  )
                })
              )}
              {this.props.tabs.map((tab: ITab, tabIndex: number) => {
                const componentFactory = React.createFactory(tab.page.component);
                return (
                  this.props.routeParm && <Route
                    path={'*/' + encodeURI(tab.page.routeAffix as string)}
                    render={() => componentFactory({ ...tab.page.props, unsavedChangesHandler: this.setUnsavedChangesFlag })}
                    key={tabIndex}
                  />
                )
              })}
              {this.props.tabs.map((tab: ITab, tabIndex: number) => {
                const componentFactory = React.createFactory(tab.page.component)
                return (
                  !this.props.routeParm && this.activeTab === tabIndex && componentFactory({ ...tab.page.props, unsavedChangesHandler: this.setUnsavedChangesFlag, key: tabIndex })
                )
              })}
            </Switch>
          </div>
        </div>
        <Dialog
          open={this.state.openDialog}
          onClose={this.closeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Unsaved changes detected!</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Save or discard your changes, before leaving this page.
                        </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(TabNavigation)



// WEBPACK FOOTER //
// ./src/modules/shared/components/TabNavigation.tsx